import { render } from "./ComponentShowcase.vue?vue&type=template&id=61e3d82e"
import script from "./ComponentShowcase.vue?vue&type=script&lang=js"
export * from "./ComponentShowcase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__